import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Flex } from "@edricphan2022/uikit";
import { Text } from "@edricphan2022/uikit";
import OrbitIcon from "../../assets/Home/Logo/orbit-icon.svg";
import OrbitIconWhite from "../../assets/Home/Logo/OrbitIconWhite.svg";

interface LogoProps {
  href: string;
  isWhite?: boolean;
}

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  flex-direction: column;
  transition: 0.3s ease;
  padding: 29px 0 23px 0;

  &:hover {
    transform: rotate(-5deg);
  }
  img{
    width: 100%;
    max-width: 200px;
  }
  .text-orbit {
    font-weight: 500;
    font-family: ManropeMedium;
    :nth-child(2){
      letter-spacing: 0.155em;
    }
  }
`;

const IconOrbit = styled.img`
  width: 100%;
  height: 41.5px;
  display: block;
`;

const LogoOrbit: React.FC<LogoProps> = ({ href, isWhite }) => {
  const isAbsoluteUrl = href.startsWith("http");
  const innerLogo = (
    <>
      {isWhite ? (
        <IconOrbit src={OrbitIconWhite} alt="icon-orbit" className="desktop-icon" />
      ) : (
        <IconOrbit src={OrbitIcon} alt="icon-orbit" className="desktop-icon" />
      )}
    </>
  );

  return (
    <Flex mr={["0px", "10px", "20px", "44px"]}>
      {isAbsoluteUrl ? (
        <StyledLink as="a" href={href} aria-label=" home page">
          {innerLogo}
          <Text className="text-orbit" as="h1">
            Wikex Exchange
          </Text>
        </StyledLink>
      ) : (
        <StyledLink to={href} aria-label=" home page">
          {innerLogo}
          {/* <Text className="text-orbit" as="h1" color={isWhite ? "#FFFFFF" : "#333333"}>
          Universe Orbit 
          </Text> */}
        </StyledLink>
      )}
    </Flex>
  );
};

export default LogoOrbit;
